/*
 * validate-item.ts
 * Description: Includes the declaration
 * of the validate item function
 */

// Importing strings
import {
    MissingSize,
} from '../variables';

/**
 * Validating an item
 *
 * @return {Object} Promise - a list of all municipalities
 */
// TODO: add types to the parameters and fix JSDoc comment
export function validateItem(errors: string[], addons, tempAddons, variantions) {
    // Validating first name
    if (variantions.length === 0) { errors.push(MissingSize); }

    for (const item of addons) {
        if (tempAddons[item.name].length < item.minimum_selected) {
            errors.push('Добавката ' + item.name + ' трябва да има поне ' + item.minimum_selected + ' избрани.');
        }
        if (tempAddons[item.name].length > item.maximum_selected) {
            errors.push('Добавката ' + item.name + ' трябва да има най-много ' + item.maximum_selected + ' избрани.');
        }
    }
}
